export default __webpack_public_path__ + "static/media/151-text-file.8638dc46.png";